import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import ListIcon from '@mui/icons-material/List';
import Typography from '@mui/material/Typography';
//import InputAdornment from "@mui/material/InputAdornment";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'; // createFilterOptions vẫn ở đây
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash.debounce'; // Import debounce
import withList from './withList'; // Giữ nguyên HOC
import AuthContext from "./auth/Context"; // Giữ nguyên context
import {CircularProgress } from '@mui/material'; // Thêm CircularProgress


class AutoCompleteInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value, // Giá trị thực (ví dụ: ID)
      itemSelected: this.props.multiple ? [] : null, // Object(s) đã chọn
      items: Array.isArray(this.props.items) ? this.props.items : [], // Danh sách options
      loading: false,
      load: 0, // Dùng để force re-render, giữ lại logic cũ
      open: false,
      inputValue: '', // Giá trị text người dùng nhập vào
    };
    this.items_cache = {};
    this.filter = createFilterOptions({
      matchFrom: 'any', // 'this.props.model==="account"?'any':'any' là dư thừa
      stringify: option => {
        let str = '';
        if (this.props.field4Search) {
          this.props.field4Search.split(",").forEach(field => {
            str = `${str}${option[field.split(":").pop()] || ""}`
          })
        } else {
          let label = option[this.props.labelField] || "";
          let value = option[this.props.valueField] || "";
          str = `${value}${label}`
        }
        return str;
      },
    });
    this._all_ = null; // Cache cho toàn bộ danh sách ban đầu
    this.masterData = cloneDeep(this.props.masterData || {});
    this.renderOption = this.renderOption.bind(this);

    // Kiểm tra xem this.props.items có phải là hàm để fetch không
    this.isFetchFunction = typeof this.props.items === 'function';

    if (this.isFetchFunction) {
      // Hàm thực hiện gọi API (tách ra từ logic cũ trong onInputChange)
      this._triggerFetchActual = this._triggerFetchActual.bind(this);
      // Hàm đã được debounce
      this.debouncedFetchHandler = debounce(this._triggerFetchActual, 500); // 500ms debounce
    }
  }

  async componentDidMount() {
    this._condition = await this.getCondition(this.props.condition);
    if (this.state.value !== undefined && this.state.value !== null) {
      let itemSelected = await this.getSelectedItem(this.state.value);
      // Cập nhật cả inputValue nếu có itemSelected và không phải multiple
      let initialInputValue = '';
      if (itemSelected && !this.props.multiple && this.props.getOptionLabel) {
        initialInputValue = this.props.getOptionLabel(itemSelected);
      } else if (itemSelected && !this.props.multiple && this.props.labelField) {
        initialInputValue = itemSelected[this.props.labelField || this.props.valueField] || '';
      }
      this.setState({ itemSelected, inputValue: initialInputValue, load: this.state.load + 1 });
    }
  }

  shouldComponentUpdate(newProps, newStates) {
    // Giữ nguyên logic shouldComponentUpdate phức tạp của bạn
    // Đảm bảo nó so sánh cả inputValue nếu cần thiết
    this.checkCondition = false;
    if ((this.props.condition || newProps.condition) && !isEqual(this.masterData, (newProps.masterData || {}))) {
      this.checkCondition = true;
      this.masterData = cloneDeep(newProps.masterData || {});
      return true;
    }
    if (newStates.load !== this.state.load || newStates.open !== this.state.open || newStates.loading !== this.state.loading || newStates.inputValue !== this.state.inputValue) return true; // Thêm inputValue, loading
    if ((newProps.value !== undefined || this.props.value !== undefined) && !isEqual(newProps.value, this.props.value)) return true;
    // So sánh itemSelected vì nó được dùng làm value cho Autocomplete
    if (!isEqual(newStates.itemSelected, this.state.itemSelected)) return true;

    return false;
  }

  async componentDidUpdate(oldProps) {
    // Giữ nguyên logic componentDidUpdate phức tạp của bạn
    // Đảm bảo nó hoạt động đúng với state mới (bao gồm inputValue)
    if (this.checkCondition) {
      let newCondition = await this.getCondition(this.props.condition);
      if (!isEqual(newCondition, this._condition)) {
        this._condition = newCondition;
        this._all_ = null;
        this.items_cache = {};
        this.setState({ items: [], inputValue: '' }, async () => {
          let itemSelected = this.props.multiple ? [] : null;
          let value_is_not_valid = false;
          let value = this.props.value;
          if (value !== undefined && value !== null) {
            itemSelected = await this.getSelectedItem(value);
            value_is_not_valid = (!itemSelected || (this.props.multiple ? itemSelected.length === 0 : !itemSelected));
          }
          if (this.props.multiple) {
            value = value_is_not_valid ? [] : value;
          } else {
            value = value_is_not_valid ? null : value;
          }
          // Cập nhật inputValue dựa trên itemSelected mới
          let newInputValue = '';
          if (itemSelected && !this.props.multiple && this.props.getOptionLabel) {
            newInputValue = this.props.getOptionLabel(itemSelected);
          } else if (itemSelected && !this.props.multiple && this.props.labelField) {
            newInputValue = itemSelected[this.props.labelField || this.props.valueField] || '';
          }

          this.setState({ itemSelected, value, inputValue: newInputValue, load: this.state.load + 1 }, () => {
            if (value_is_not_valid && this.props.onValueChanged) {
              // ... (logic onValueChanged khi không hợp lệ)
               if(this.props.multiple){
                this.props.onValueChanged([],[],[]);
              }else{
                this.props.onValueChanged(null,null,{});
              }
            }
          });
        });
        return;
      }
    }
    if ((this.props.value !== undefined || oldProps.value !== undefined) && !isEqual(this.props.value, oldProps.value) && !isEqual(this.props.value, this.state.value)) {
      let value = this.props.value;
      let itemSelected;
      let value_is_not_valid = false;
      if (value !== undefined && value !== null) {
        itemSelected = await this.getSelectedItem(value);
        value_is_not_valid = (!itemSelected || (this.props.multiple ? itemSelected.length === 0 : !itemSelected));
        if (this.props.multiple) {
          value = itemSelected && itemSelected.length !== 0 ? value : [];
        } else {
          value = itemSelected ? value : null;
        }
      } else {
        itemSelected = this.props.multiple ? [] : null;
        value = this.props.multiple ? [] : null;
      }
       // Cập nhật inputValue dựa trên itemSelected mới
      let newInputValue = '';
      if (itemSelected && !this.props.multiple && this.props.getOptionLabel) {
        newInputValue = this.props.getOptionLabel(itemSelected);
      } else if (itemSelected && !this.props.multiple && this.props.labelField) {
        newInputValue = itemSelected[this.props.labelField || this.props.valueField] || '';
      }

      this.setState({ itemSelected, value, inputValue: newInputValue, load: this.state.load + 1 }, () => {
        if (value_is_not_valid && this.props.onValueChanged) {
            // ... (logic onValueChanged khi không hợp lệ)
            if(this.props.multiple){
                this.props.onValueChanged([],[],[]);
            }else{
                this.props.onValueChanged(null,null,{});
            }
        }
      });
    }
  }

  componentWillUnmount() {
    if (this.isFetchFunction) {
      this.debouncedFetchHandler.cancel(); // Hủy debounce khi component unmount
    }
  }

  // getCondition, getItem, getSelectedItem giữ nguyên logic của bạn
  async getCondition(_condition) {
    let condition;
    if (!_condition) _condition = this.props.condition;
    if (_condition) {
      if (_condition && _condition.then) {
        condition = await _condition;
      } else {
        if (typeof (_condition) === "object") {
          condition = _condition;
        } else {
          try { condition = JSON.parse(_condition); } catch (e) { console.error(e.message, _condition) }
        }
      }
    }
    return condition;
  }

  async getItem(value) { // value ở đây là primitive value
    if (value === undefined || value === null) return undefined; // Sửa điều kiện check value

    // Tìm trong items hiện tại
    let item = this.state.items.find(i => i && i[this.props.valueField] === value);
    if (item) return item;

    // Tìm trong itemSelected hiện tại (quan trọng khi props.value thay đổi)
    if (!this.props.multiple && this.state.itemSelected && this.state.itemSelected[this.props.valueField] === value) {
        return this.state.itemSelected;
    }
    if (this.props.multiple && Array.isArray(this.state.itemSelected)) {
        const foundInSelected = this.state.itemSelected.find(i => i && i[this.props.valueField] === value);
        if (foundInSelected) return foundInSelected;
    }


    // Logic giữ lại item nếu có label (cho trường hợp giá trị không có trong danh sách nhưng vẫn muốn hiển thị)
    if (!this.checkCondition && value === this.props.value && (!this.props.labelField || this.props.label)) {
      item = { [this.props.valueField]: value };
      if (this.props.labelField && this.props.label !== undefined) { // Check this.props.label
        item[this.props.labelField] = this.props.label;
      }
      return item;
    }

    // Fetch từ server nếu là hàm
    if (this.isFetchFunction) {
      try {
        // Không nên await this.getCondition ở đây vì _condition đã được cập nhật
        let items = await this.props.items({ ...this._condition, [this.props.valueField]: value, status:true }, { cache: true, limit: 1, online: true });
        item = items.find(i => i && i[this.props.valueField] === value);
      } catch (e) {
        console.error(e.message);
      }
    }
    return item;
  }

  async getSelectedItem(values) { // values là primitive value(s)
    if (this.props.multiple) {
      let selectedItems = [];
      if (values && Array.isArray(values)) {
        // Loại bỏ giá trị trùng lặp và null/undefined
        const uniqueValues = [...new Set(values)].filter(v => v !== undefined && v !== null);
        selectedItems = (await Promise.all(uniqueValues.map(value => this.getItem(value)))).filter(item => !!item); // Lọc bỏ item undefined
      }
      return selectedItems;
    } else {
      if (values === undefined || values === null) return null;
      return await this.getItem(values);
    }
  }
  
  // Hàm thực hiện gọi API, được gọi bởi debouncedFetchHandler
  async _triggerFetchActual(inputValueToSearch) {
    if (!this.isFetchFunction) return;

    // Kiểm tra cache nội bộ trước khi gọi API
    if (this.items_cache[inputValueToSearch] && this.items_cache[inputValueToSearch].length > 0) {
      // Chỉ cập nhật state nếu inputValue hiện tại vẫn khớp với giá trị đang tìm kiếm
      // (để tránh race condition nếu người dùng gõ nhanh)
      if (inputValueToSearch === this.state.inputValue) {
        this.setState({ items: this.items_cache[inputValueToSearch], loading: false, load: this.state.load + 1 });
      }
      return;
    }

    this.setState({ loading: true });

    let query = { $or: [] };
    const searchValSanitized = inputValueToSearch;
    if (this.props.field4Search) {
      this.props.field4Search.split(",").filter(f => f && f !== "_id").forEach(field4Search => {
        let _field4Search = field4Search.split(":");
        let field = _field4Search.pop();
        let label = _field4Search.pop();
        let type = _field4Search.shift();
        
        if(type && type.toLowerCase()==="number"){
          try{
            let number_value = Number(searchValSanitized);
            if(!isNaN(number_value)){
              query.$or.push({ [field]:  number_value});
            }
            
          }catch(e){}
          
        }else{
          query.$or.push({ [field]: { $regex: searchValSanitized, $options: 'i' } });
        }
      });
    } else {
      if (this.props.valueField !== "_id") {
        query.$or.push({ [this.props.valueField]: { $regex: (this.props.model === "account" ? "^" : "") + searchValSanitized, $options: 'i' } });
      }
      if (this.props.labelField && this.props.labelField !== "_id" && this.props.labelField !== this.props.valueField) { // Thêm check labelField khác valueField
          query.$or.push({ [this.props.labelField]: { $regex: searchValSanitized, $options: 'i' } });
      }
    }

    if (query.$or.length === 0) {
      query.$text = { $search: searchValSanitized }; // Giữ lại logic search $text của bạn
      delete query.$or;
    }

    //console.log("[autocomplete] query",query);
    
    try {
      const condition = this._condition; // _condition đã được await và cập nhật
      const fetchedItems = await this.props.items({ ...condition, ...query, status: true }, { limit: 20, online: true, cache: false });

      if (Array.isArray(fetchedItems)) {
        this.items_cache[inputValueToSearch] = fetchedItems; // Cache kết quả
        if (inputValueToSearch === this.state.inputValue) { // Chỉ cập nhật nếu input chưa thay đổi
          this.setState({ items: fetchedItems, load: this.state.load + 1 });
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      /*// Chỉ tắt loading nếu đây là request cuối cùng cho input hiện tại
      if (inputValueToSearch === this.state.inputValue) { 
        this.setState({ loading: false });
      }*/
      this.setState({ loading: false });
    }
  }
  
  // renderOption và openList giữ nguyên logic của bạn
  renderOption(props, option) { // MUI v5 renderOption có props là argument đầu tiên
    let label = option[this.props.labelField || this.props.valueField] || option.action_text || option.open_list || "";
    if (option.action_text || option.open_list) {
      return <li {...props} key={label + (option.action_text || option.open_list)}><Button variant="outlined" color="primary" size="small" fullWidth>{label}</Button></li>
    }

    if (this.props.renderOption) {
      return this.props.renderOption(props, option); // Truyền props cho custom renderOption
    } else {
      let paddingLeft = 15 * ((option.bac || 1) - 1);
      let fontWeight = (option.loai_nh === 0 ? "bold" : undefined);
      if (this.props.field4Search) {
        return (
          <li {...props} key={option[this.props.valueField] || JSON.stringify(option)} style={{ paddingLeft, fontWeight, display: 'block',borderBottom:'1px solid #ddd' }}> {/* display: 'block' or flex */}
            {this.props.field4Search.split(",").map((field4Search, index) => {
              let _field4Search = field4Search.split(":");
              let field = _field4Search.pop();
              let label = _field4Search.pop();
              let type = _field4Search.pop();
              if(!option[field]) return null;
              
              let value = option[field];
              if(type && type.toLowerCase()=="number"){
                value = formatNumber(value);
              }

              if (index === 0) {
                return <Typography style={{ fontWeight: 400 }} key={index.toString()}>{value}</Typography>
              }
              return <div key={index.toString()} style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"center"}}>
                {!!label && <Typography variant="caption" style={{paddingRight:5}}>{label}:</Typography>}
                <Typography>{value}</Typography>
              </div>
            })}
          </li>
        )
      } else {
        let value = (option[this.props.valueField] || "").toString();
        return (
          <li {...props} key={option[this.props.valueField] || label} style={{ paddingLeft, fontWeight }}>
            {label}
            {!!this.props.labelField && this.props.valueField !== "_id" && value &&
              <small style={{paddingLeft:10}}>({value})</small>
            }
          </li>
        )
      }
    }
  }
  openList() { /* Giữ nguyên */ 
    if(this.props.notAdd) return;
    let condition = this._condition || {}; 
    condition.status = true;
    if(this.props.multiple){
      this.context.objectPicker(this.props.model,"",{condition,defaultData:{...condition}
        ,callback:(selecteds)=>{
          selecteds = selecteds.filter(item=>item.status==true);
          if(selecteds.length==0) return;
          let itemSelected = this.state.itemSelected || [];
          selecteds.forEach(selected=>{
            if(!itemSelected.find(item=>item && item[this.props.valueField]===selected[this.props.valueField])){
              itemSelected.push(selected)
            }
          })
          let _values = itemSelected.map(item=>item && item[this.props.valueField]);
          _values = [...new Set(_values)];
          this.setState({itemSelected:itemSelected,value:_values,load:this.state.load+1},()=>{
            if(this.props.onValueChanged){
              this.props.onValueChanged(_values,itemSelected,itemSelected);
            }
          });
        },
        props:{
          multiSel:true,
          mediaQueryMatches:this.props.mediaQueryMatches,
        }
      });
    }else{
      let value,label;
      this.context.objectPicker(this.props.model,"",{condition,defaultData:{...condition},
        callback:(selected)=>{
          if(selected.status==false){
            return this.context.alert(this.context.apis.getLabel("Đối tượng này đã ngừng sử dụng"));
          }
          value = selected[this.props.valueField];
          label = selected[this.props.labelField||this.props.valueField];
          this.setState({value:value,itemSelected:selected,load:this.state.load+1, inputValue: label},()=>{ // Cập nhật inputValue ở đây
            if(this.props.onValueChanged){
              this.props.onValueChanged(value,label,selected);
            }
          })

        },
        props:{
          multiSel:false,
          mediaQueryMatches:this.props.mediaQueryMatches,
        }
      });
    }
  }
  async handleValueChanged(newItemSelected){ 
    //Huỷ fetch data
    if (this.debouncedFetchHandler) this.debouncedFetchHandler.cancel();
    //Xử lý nếu cho phép chọn nhiều giá trị
    if(this.props.multiple){
      if(newItemSelected.length>0 && ((newItemSelected[newItemSelected.length-1]||{}).action_text ||  (newItemSelected[newItemSelected.length-1]||{}).open_list) ){
        let new_item = newItemSelected[newItemSelected.length-1];
        let inputValue = new_item.inputValue;
        const listModel = await this.props.getListModel();
        if(listModel){
          if((new_item||{}).open_list){ this.openList(); return; }
          if((new_item||{}).action_text && this.props.notAdd!=true){
            let _value,condition;
            condition = this._condition;
            _value = Object.assign({},condition||{});
            if(this.props.labelField) _value[this.props.labelField] = inputValue;
            listModel.quickAdd(_value,(rs)=>{
              if(this._all_){ this._all_.push(rs); }
              for(let key in rs){ new_item[key] = rs[key]; }
              delete new_item.action_text; delete new_item.inputValue;
              let _values = newItemSelected.filter(item=>item).map(item=>item[this.props.valueField]);
              _values = [...new Set(_values)];
              this.setState({itemSelected:newItemSelected,value:_values,loading: false,load:this.state.load+1},()=>{
                if(this.props.onValueChanged){ this.props.onValueChanged(_values,newItemSelected,newItemSelected); }
              });
            })
          }
        }
      }else{
        newItemSelected = newItemSelected.filter(item=>!(item||{}).open_list && !(item||{}).action_text);
        let _values = newItemSelected.filter(item=>item).map(item=>item[this.props.valueField]);
        _values = [...new Set(_values)];
        // Với multiple, sau khi chọn xong có thể muốn xóa inputValue
        this.setState({itemSelected:newItemSelected,value:_values, inputValue: '',loading: false, load:this.state.load+1},()=>{
          if(this.props.onValueChanged){ this.props.onValueChanged(_values,newItemSelected,newItemSelected); }
        });
      }
      return;
    }
    let value,label, finalInputValue = this.state.inputValue;
    if(newItemSelected){
      if(newItemSelected.action_text && this.props.notAdd!=true){
        const listModel = await this.props.getListModel();
        if(listModel){
          let _value,condition;
          condition = this._condition || {};
          _value = Object.assign({},condition||{});
          if(this.props.labelField) _value[this.props.labelField] = newItemSelected.inputValue;
          listModel.quickAdd(_value,(rs)=>{
            if(this._all_){ this._all_.push(rs); }
            value = rs[this.props.valueField];
            label = rs[this.props.labelField||this.props.valueField];
            finalInputValue = label; // Cập nhật inputValue
            this.setState({items: this._all_ ? [...this._all_] : this.state.items, value:value,itemSelected:rs, inputValue: finalInputValue,loading: false, load:this.state.load+1},()=>{
              if(this.props.onValueChanged){ this.props.onValueChanged(value,label,rs); }
            })
          })
        }
        return;
      }
      if((newItemSelected||{}).open_list){ this.openList(); return; }
      value = newItemSelected[this.props.valueField];
      label = newItemSelected[this.props.labelField||this.props.valueField];
      finalInputValue = label; // Cập nhật inputValue
    }else{
      value=null; label=""; finalInputValue = ""; // Xóa inputValue nếu itemSelected là null
    }
    this.setState({value:value,itemSelected:newItemSelected, inputValue: finalInputValue,loading: false, load: this.state.load+1},()=>{ // Thêm load update
      if(this.props.onValueChanged){ this.props.onValueChanged(value,label,newItemSelected); }
    })
  }

  render() {
    const { variant, notAdd, multiple, margin, inline, disabled, readOnly, required, autoFocus, inputLabel, helperText, InputProps: userGivenInputProps, getOptionLabel: userGetOptionLabel, labelField, valueField, model, fullWidth, id, mediaQueryMatches } = this.props;
    const { itemSelected, items, loading, open, inputValue } = this.state;

    let defaultInputPropsForMobile = (mediaQueryMatches||this.context.config?.isMobile) ? {
      disableUnderline: true,
      style: {
        maxWidth: inline ? 200 : undefined,
        padding: 5,
        border: "1px solid #B9B9B9",
        borderRadius: 3,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: disabled || readOnly ? '#f5f5f5' : undefined
      }
    } : {};

    if ((disabled || readOnly) && !multiple) {
      const displayValue = itemSelected ? (userGetOptionLabel ? userGetOptionLabel(itemSelected) : (itemSelected[labelField || valueField] || "")) : "";
      return (
        <TextField
          fullWidth={fullWidth}
          margin={margin}
          variant={variant}
          value={displayValue}
          readOnly={true}
          InputLabelProps={{ shrink: true }}
          InputProps={{ ...defaultInputPropsForMobile, ...(userGivenInputProps || {}) }}
          label={inputLabel} />
      )
    }

    let tooltip_content = "";
    if (itemSelected && !multiple && labelField && labelField !== valueField && itemSelected[labelField] != itemSelected[valueField]) {
      tooltip_content = `${itemSelected[valueField]}`;
      if (itemSelected[labelField]) {
        tooltip_content = `${tooltip_content} - ${itemSelected[labelField]}`
      }
    }

    const customPopupIcon = (this.props.notAdd !== true) ? (
      <ListIcon onClick={() => {
        if (this.props.model) {
          this.openList(); // Gọi hàm openList của bạn
        } else {
          // Logic khi không có model (ví dụ: chỉ mở dropdown hoặc fetch all)
          if (this.isFetchFunction && this._all_) {
            this.setState({ items: this._all_, open: !this.state.open });
          } else if (this.isFetchFunction) {
            this._triggerFetchActual(''); // Fetch all
            this.setState({ open: !this.state.open });
          } else {
            this.setState({ open: !this.state.open });
          }
        }
      }}/>
    ) : undefined; // Nếu notAdd là true, dùng popupIcon mặc định (hoặc không có nếu Autocomplete không tự thêm)


    return (
      <Tooltip title={tooltip_content}>
        <Autocomplete
          id={id || `autocomplete-${valueField}`} // Cần id duy nhất
          multiple={multiple}
          options={items}
          fullWidth={fullWidth}
          loading={loading}
          value={itemSelected} // Autocomplete value là object itemSelected
          disabled={disabled || readOnly}
          autoSelect={this.props.autoSelect !== undefined ? this.props.autoSelect : false} // Truyền prop từ props
          autoHighlight={this.props.autoHighlight !== undefined ? this.props.autoHighlight : true} // Truyền prop từ props
          disableCloseOnSelect={multiple} // Giữ mở nếu là multiple
          style={{ minWidth: 100, ...this.props.style }} // Thêm style từ props
          // SỬA LẠI isOptionEqualToValue
          isOptionEqualToValue={(option, val) => option && val && option[valueField] === val[valueField]}
          onChange={(event, newItemSelected) => this.handleValueChanged(newItemSelected)}
          inputValue={inputValue}
          open={open}
          onClose={() => this.setState({ open: false })}
          componentsProps={{
              popper: {
                  sx: { zIndex: (theme) => theme.zIndex.modal + 9999  }
              }
          }}
          onOpen={async () => {
            this.setState({ open: true });
            if (this.isFetchFunction) {
              if ((!this._all_ || this._all_.length === 0) && !inputValue) { // Chỉ fetch all nếu chưa có và không có input
                this.setState({ loading: true });
                try {
                  const condition = this._condition;
                  const fetched = await this.props.items({ ...condition, status: true }, { limit: 20, online: true, cache: false });
                  if (Array.isArray(fetched)) {
                    if (fetched.length > 0 && !inputValue) this._all_ = fetched; // Chỉ cache _all_ nếu không có inputValue lúc fetch
                    this.setState({ items: fetched, load: this.state.load + 1 });
                  }
                } catch (e) { console.error(e); }
                finally { this.setState({ loading: false }); }
              } else if (inputValue) {
                  // Nếu có inputValue khi mở, có thể trigger fetch cho nó (không debounce)
                  this._triggerFetchActual(inputValue);
              } else if (this._all_ && !inputValue) {
                  this.setState({ items: this._all_ });
              }
            } else if (Array.isArray(this.props.items)) {
              this.setState({items: this.props.items, load: this.state.load+1})
            }
          }}
          filterOptions={(options, params) => {
            if (!this.isFetchFunction && !params.inputValue) { // Nếu là local array và không có input, trả về hết
                // return options; // Bỏ qua filter mặc định nếu không muốn client-side filter
            }
            // Nếu là fetch function, server đã filter, ta chỉ filter lại (nếu cần) và thêm custom options
            // Hoặc nếu là local array, ta filter rồi thêm custom options
            const filtered = this.filter(options, params); // this.filter là createFilterOptions của bạn

            if (model && notAdd != true && !this.state.loading) {
              if (params.inputValue !== '') {
                filtered.push({
                  inputValue: params.inputValue,
                  action_text: `Thêm "${params.inputValue}"`,
                  [valueField]: `_add_${params.inputValue}`, // Cần valueField duy nhất
                  [labelField || valueField]: `Thêm "${params.inputValue}"`
                });
              }
              /*filtered.push({
                open_list: "Mở danh mục",
                [valueField]: `_open_list_`, // Cần valueField duy nhất
                [labelField || valueField]: "Mở danh mục"
              });*/
            }
            return filtered;
          }}
          onInputChange={(event, newInputValue, reason) => {
            if (reason === 'reset' && !this.props.freeSolo && !multiple) {
                 // Khi một item được chọn (không phải freeSolo, không phải multiple),
                 // inputValue được cập nhật thành label của item đó.
                 // Không cần trigger fetch mới ở đây.
                 this.setState({ inputValue: newInputValue });
                 return;
            }

            this.setState({ inputValue: newInputValue }, () => {
              if (this.isFetchFunction) {
                if (newInputValue === '') {
                  if (this.debouncedFetchHandler) this.debouncedFetchHandler.cancel();
                  this.setState({ items: this._all_ || [], loading: false, load: this.state.load + 1 });
                } else if (reason === 'input') { // Chỉ fetch khi người dùng gõ
                  if (this.debouncedFetchHandler) this.debouncedFetchHandler(newInputValue);
                }
              }
              // Nếu không phải isFetchFunction, Autocomplete sẽ tự filter dựa trên this.state.items (đã được set từ props.items)
            });
          }}
          getOptionLabel={(option) => {
            // Xử lý trường hợp option là string (khi freeSolo và người dùng nhập text mới)
            if (typeof option === 'string') {
              return option;
            }
            // Xử lý các object option tùy chỉnh (action_text, open_list)
            if (option.action_text) return option.action_text;
            if (option.open_list) return option.open_list;

            // Logic getOptionLabel của bạn
            if (userGetOptionLabel) {
              return userGetOptionLabel(option);
            } else {
              return option[labelField || valueField] || "";
            }
          }}
          renderOption={this.renderOption}
          popupIcon={customPopupIcon}
          renderInput={params => {
            let mergedInputProps = {
                ...params.InputProps,
                ...defaultInputPropsForMobile,
                ...(userGivenInputProps || {}),
                endAdornment: (
                  <>
                      {loading ? <CircularProgress color="inherit" size={20} style={{ marginRight: 8 }} /> : null}
                      {params.InputProps.endAdornment} {/* Giữ lại clear button hoặc các adornment khác từ Autocomplete */}
                  </>
                )
            };
            
            return (
              <TextField {...params}
                variant={variant}
                margin={margin}
                style={{ marginTop: inline ? 0 : undefined, minWidth: this.props.minWidth||100 }}
                required={required && !this.props.noValidate} // Thêm check noValidate từ props
                autoFocus={autoFocus}
                onBlur={()=>{
                  //Tắt loading nếu user đã thoạt khoải component
                  if(this.debouncedFetchHandler) this.debouncedFetchHandler.cancel();
                  this.setState({loading:false});
                }}
                // inputRef={ref => this.inputRef = ref} // inputRef nên được truyền qua params cho Autocomplete
                //InputLabelProps={{ shrink: true, ...params.InputLabelProps }}
                //InputProps={mergedInputProps}
                slotProps={{
                   
                    input:mergedInputProps,
                    inputLabel:{ shrink: true, ...params.InputLabelProps }

                }}
                
                helperText={helperText}
                placeholder={inline ? inputLabel : ""}
                label={inline ? "" : inputLabel}
                
              />
            )
          }}
          slots={{
            paper:({ children }) => (
              <Paper style={{ padding: 5, backgroundColor: "#F3F2F3" }} elevation={2}>{children}</Paper>
            )
          }}
          /*PaperComponent={({ children }) => (
            <Paper style={{ padding: 5, backgroundColor: "#F3F2F3" }} elevation={2}>{children}</Paper>
          )}*/
          // freeSolo={this.props.freeSolo} // Nếu bạn có prop freeSolo
        />
      </Tooltip>
    );
  }
}

AutoCompleteInput.propTypes = {
  id: PropTypes.string,
  getListModel: PropTypes.func.isRequired,
  onValueChanged: PropTypes.func,
  model: PropTypes.string,
  condition: PropTypes.any,
  value: PropTypes.any,
  label: PropTypes.string, // Dùng để hiển thị khi value không có trong items
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  fullWidth: PropTypes.bool,
  multiple: PropTypes.bool,
  valueField: PropTypes.string.isRequired,
  labelField: PropTypes.string,
  inputLabel: PropTypes.string,
  margin: PropTypes.string,
  field4Search: PropTypes.string,
  renderOption: PropTypes.func,
  getOptionLabel: PropTypes.func,
  notAdd: PropTypes.bool,
  autoFocus: PropTypes.bool,
  autoSelect: PropTypes.bool,
  autoHighlight: PropTypes.bool,
  freeSolo: PropTypes.bool,
  inline: PropTypes.bool,
  variant: PropTypes.string,
  mediaQueryMatches: PropTypes.bool,
  helperText: PropTypes.string,
  items: PropTypes.any.isRequired,
  style: PropTypes.object,
  InputProps: PropTypes.object, // Để truyền InputProps tùy chỉnh vào TextField
  noValidate: PropTypes.bool,
};
AutoCompleteInput.defaultProps = {
    fullWidth: true,
    margin:"normal",
    noValidate:false
}
AutoCompleteInput.contextType = AuthContext;
export default withList(AutoCompleteInput);